import { IconSearch } from '@tabler/icons-react'
import { MYNAVI_PRIMARY } from '../Color'

export type MyNaviButtonProps = {
  label?: string
  /** 吹き出しに表示する検索結果件数。undefined の場合は吹き出し非表示 */
  resultCount?: number
  onClick?: () => void
  fullWidth?: boolean
  /** 検索アイコンを表示するか否か。デフォルト true */
  showIcon?: boolean
  disabled?: boolean
  /** ボタンの type 属性。デフォルト 'button' */
  type?: 'button' | 'submit' | 'reset'
  /** ローディング中はスピナーを表示しボタンを無効化する */
  loading?: boolean
}

const LoadingSpinner = () => (
  <svg
    aria-hidden="true"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    style={{ animation: 'spin 0.75s linear infinite' }}
  >
    <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
    <circle cx="9" cy="9" r="7" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2.5" />
    <path d="M9 2 a7 7 0 0 1 7 7" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
)

export const MyNaviButton = ({
  label = '検索',
  resultCount,
  onClick,
  fullWidth = true,
  showIcon = true,
  disabled = false,
  type = 'button',
  loading = false,
}: MyNaviButtonProps) => {
  const isDisabled = disabled || loading
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: fullWidth ? '100%' : undefined,
      }}
    >
      {resultCount !== undefined && (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '5px',
          }}
        >
          {/* 検索結果バッジ：高さ24px・角丸4px（Figma: 検索結果枠2） */}
          <div
            style={{
              backgroundColor: 'white',
              border: `1px solid ${MYNAVI_PRIMARY}`,
              borderRadius: '4px',
              height: '24px',
              padding: '0 12px',
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <span
              style={{
                fontSize: '14px',
                color: '#686868',
                fontFamily: "'Noto Sans JP', sans-serif",
              }}
            >
              検索結果：{resultCount}校
            </span>
          </div>
          {/* 吹き出しの尾：バルーン下辺ボーダーに1px重ねて配置（Figma: 検索結果枠1/枠3）
              position:absolute で bottom:-9px にし、SVG top がバルーン下辺ボーダー（y=23px）に重なる。
              白い内側ポリゴンがバルーン底辺ボーダーの中央部を隠し、
              外側のプライマリ枠線がバルーン枠線と自然につながる。
              position指定のSVGは静的なバルーンdivより後に描画されるため、
              z-index不要でバルーン上に重なる。 */}
          <svg
            width="21"
            height="10"
            viewBox="0 0 21 10"
            style={{
              display: 'block',
              position: 'absolute',
              bottom: '-9px',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
            aria-hidden="true"
          >
            {/* 外側ポリゴン（プライマリカラー）：三角の枠線を形成 */}
            <polygon points="0,0 21,0 10.5,10" fill={MYNAVI_PRIMARY} />
            {/* 内側ポリゴン（白塗り）：バルーン底辺ボーダー中央を隠し三角内部を白にする */}
            <polygon points="1,0 20,0 10.5,9" fill="white" />
          </svg>
        </div>
      )}
      <button
        type={type}
        onClick={onClick}
        disabled={isDisabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          backgroundColor: isDisabled ? '#CDCECF' : MYNAVI_PRIMARY,
          color: 'white',
          height: '47px',
          width: fullWidth ? '100%' : undefined,
          padding: fullWidth ? undefined : '0 32px',
          borderRadius: '8px',
          border: 'none',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          fontSize: '16px',
          fontWeight: 400,
          fontFamily: "'BIZ UDPGothic', sans-serif",
        }}
      >
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            {showIcon && <IconSearch size={20} color="white" stroke={2} />}
            {label}
          </>
        )}
      </button>
    </div>
  )
}
